import { Suspense } from 'react';

import { Skeleton } from '@ui';

import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import { BankSelectionModal } from '../../../modals/BankSelectionModal/BankSelectionModal';
import { useOpenBankingEntry } from '../../../modals/BankSelectionModal/useOpenBankingEntry';
import { OpenBankingStatusCard } from '../../../ui/OpenBankingStatusCard/OpenBankingStatusCard';

export const OpenBankingStatusWidget = () => {
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense
                fallback={<Skeleton className="h-[140px] w-full rounded-s" />}
            >
                <OpenBankingStatusWidgetContent />
            </Suspense>
        </ErrorBoundary>
    );
};

const OpenBankingStatusWidgetContent = () => {
    const { status, openModal, modalProps } =
        useOpenBankingEntry('dashboard_widget');

    return (
        <>
            <OpenBankingStatusCard status={status} onAction={openModal} />
            <BankSelectionModal {...modalProps} />
        </>
    );
};
